import React from 'react';
import { withStyles } from 'material-ui';

import { getUserInformation, logout } from '../Login/loginService';
import { listReservations } from '../Reservations/reservationsServices';
import SideBarMenu from './SideBarMenu';
import moment from 'moment';
import { translate } from 'react-i18next';
import { getCMSConfiguration } from '../../cms/cmsLib';

const styles = theme => ({
    list: {
        width: 220,
    },
    listFull: {
        width: 'auto',
    },
    avatar: {
        marginTop: 10,
        marginBottom: 10,
        marginRight: 'auto',
        marginLeft: 'auto'
    },
    smallAvatar: {
        marginLeft: 8,
    },
    bigAvatar: {
        width: 60,
        height: 60,
    },
    userName: {
        margin: 'auto',
        textAlign: 'center',
        width: '200px',
        overflow: 'hidden',
        fontWeight: 300,
        color: theme.palette.primary.contrastText,
        wordWrap: 'normal',
        whiteSpace: 'normal'
    },
    userDetails: {
        paddingLeft: '10px',
        fontSize: '12px',
        fontWeight: 400,
        marginBottom: '8px',
        color: '#9dbcdb',
    },
    buildVersion: {
        color: theme.palette.primary.contrastText,
        fontSize: '10px',
        textAlign: 'right',
        paddingRight: '5px',
    },
    disabledFocusWrapper: {
        backgroundColor: 'transparent',
        overflow: 'hidden',
        '&:focus': {
            outline: 0
        }
    },
    exitText: {
        color: theme.palette.primary.contrastText,
        textDecoration: 'none'
    },
    exitIcon: {
        color: theme.palette.background.error,
        width: '32px',
        height: '32px'
    },
    dotted: {
        width: '20px',
        color: theme.palette.primary.contrastText,
        border: 'none',
        borderTopStyle: 'dotted',
        borderTopWidth: '4px',
        marginTop: '20px',
        marginBottom: '20px'
    }

});

class SideBar extends React.Component {
    constructor(props) {
        super(props);
        this.toggleDrawer = this.toggleDrawer.bind(this);
        this.state = {
            reservasmes: 0,
            open: true,
            webColours: []
        };
        this.TIME_OUT_CHECK = 1000 * 60;
        //Esto obtiene el user object alojado en la sesion
        this.user = getUserInformation();
        this.cmsConfig = getCMSConfiguration();
        this.links = this.cmsConfig.links;
        if (this.user != null) {
            this.user_detail = this.user.user_detail;
        }
        window.addEventListener('connectionChange', this.connectionChanged, false);
    }

    connectionChanged = (event) => {
        if (event.connected) {
            this.user = getUserInformation();
            this.cmsConfig = getCMSConfiguration();
            this.links = this.cmsConfig.links;
            if (this.user != null) {
                this.user_detail = this.user.user_detail;
            }
        }
    }

    componentDidMount() {
        /*this.queryReservations();
        let scope = this;
        this.to = setTimeout(function () {
            scope.queryReservations();
        }, this.TIME_OUT_CHECK);
        */
        //this.fetchColours();
    }
    componentWillUnmount() {
        clearInterval(this.to);
    }

    queryReservations = () => {
        let dd = new Date();
        let filters = {
            clientLocator: '',
            reservationState: 'all', //vacio es todas
            dateType: 'FR',
            fromDate: moment(dd),
            toDate: moment(dd),
            clientName: '',
        };
        listReservations(filters)
            .then(data => {
                if (data) {
                    this.setState({ reservasmes: data.length });
                    clearInterval(this.to);
                    let scope = this;
                    this.to = setTimeout(function () {
                        scope.queryReservations();
                    }, this.TIME_OUT_CHECK);
                }
            })
            .catch(reason => {
                //this.setState({ data: [], loading: false });
            });
    };

    toggleDrawer() {
        if (this.props.onToggle) {
            this.props.onToggle();
        }
    }

    promptExit = () => {
        let response = window.confirm(this.props.t('HOME.QUIT_MESSAGE'));
        if (response) {
            logout();
        }
    };

    async fetchColours() {
        let url = 'https://gist.githubusercontent.com/raineorshine/10394189/raw/9b8b43edda19d7fa317a18018b0fa619b53c1e8f/webcolors.json';
        const response = await fetch(url);
        let colours = [];
        try {
            colours = await response.json();
        } catch (error) {
            colours = [];
        }
        this.setState({
            webColours: colours
        });
    }
    render() {
        const { classes } = this.props;
        let currentpage = window.location.hash;
        const sideList = (
            <div className={classes.list}>
                <SideBarMenu currentpage={currentpage}
                    menudataProvider={this.links}
                    user={this.user} />
            </div>
        );
        return (
            <div
                tabIndex={0}
                className={classes.disabledFocusWrapper}
                onClick={this.toggleDrawer}
                onKeyDown={this.toggleDrawer}>
                {sideList}
            </div>
        );
    }
}

export default translate('translations')(withStyles(styles)(SideBar));


// WEBPACK FOOTER //
// ./src/components/SideBar/SideBar.js